import * as supplyLoadCoordinators from './load'
import * as supplySaveCoordinators from './save'
import * as supplyDeleteCoordinators from './delete'

export default Object.freeze({
  ...supplyLoadCoordinators,
  ...supplySaveCoordinators,
  ...supplyDeleteCoordinators,
})
